import React from "react";
import { useTranslation } from 'react-i18next'; // Import the hook
import logo from "../../assets/images/weso-logo.svg";
import { Container, Navbar, Nav, Button } from 'react-bootstrap';
import {Link} from "react-router-dom";

export const Navigation: React.FC = () => {
  // 1. Get the t function (translator) and i18n instance
  const { t, i18n } = useTranslation();

  // Function to toggle language
  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'es' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <Navbar expand="lg" className="neumorphic-container mb-3 rounded-4 main-wrapper pos-f-t sticky-top">
      <Container>
        <Navbar.Brand className="col-2" href="/#root">
          <img src={logo} className="col-8" alt="logo-white" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto col-lg-9">
            <Nav.Link href="/#services">{t('navigation.services')}</Nav.Link>
            <Nav.Link href="/#features">{t('navigation.features')}</Nav.Link>
            <Nav.Link href="/#download">{t('navigation.download')}</Nav.Link>
            <Nav.Link href="/#faqs">{t('navigation.faqs')}</Nav.Link>
            <Nav.Link href="/#contact">{t('navigation.contact')}</Nav.Link>
          </Nav>

          {/* 3. Add a language switcher */}
          <Button variant="outline-secondary" className="neumorphic-button px-5 py-1 me-3" onClick={toggleLanguage}>
             {i18n.language === 'en' ? t("navigation.language.es") : t("navigation.language.en")}
          </Button>
        </Navbar.Collapse>
        <Link className="button gradient px-5 py-2 rounded-5" to="/Login">{t("navigation.login")}</Link>
      </Container>
    </Navbar>
  );
}
